import { styled, Box } from '@mui/material';

export const DashboardVariantV2CarrierContentInTransitTabTrackingSelectionContainer =
  styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  }));
